import classNames from "classnames";
import {
  DetailedHTMLProps,
  FC,
  InputHTMLAttributes,
  ReactNode,
  useState,
} from "react";
import Icon from "../Icon";
import Text from "../Text";
import styles from "./Input.module.scss";

interface PasswordInputProps
  extends Omit<
    DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    "prefix"
  > {
  label?: string;
  error?: string | false;
  suffix?: ReactNode;
  hint?: string;
  prefix?: ReactNode;
  showCount?: boolean;
  inputClassName?: string;
  variant?: "default" | "transparent";
  required?: boolean;
  eyeIcon?: boolean;
}

const PasswordInput: FC<PasswordInputProps> = ({
  label,
  className,
  error,
  suffix,
  prefix,
  hint,
  showCount,
  inputClassName,
  variant = "default",
  required,
  value,
  defaultValue,
  eyeIcon,
  type,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const contentLength = value?.toString()?.length || 0;

  return (
    <div
      className={classNames(
        styles.input_container,
        styles[variant],
        className,
        { [styles.disabled]: rest.disabled }
      )}
    >
      {label && (
        <label
          className={classNames(styles.input_label, {
            [styles.required]: required,
          })}
        >
          {label}
        </label>
      )}
      <div
        className={classNames(styles.input_field, {
          [styles.has_error]: !!error,
        })}
      >
        {prefix && <div className={styles.prefix}>{prefix}</div>}
        <input
          type={eyeIcon ? (!showPassword ? "password" : "text") : type}
          className={classNames(styles.input, inputClassName)}
          defaultValue={defaultValue}
          value={value}
          {...rest}
        />
        {suffix && <div className={styles.suffix_icon}>{suffix}</div>}
        {eyeIcon && (
          <div className={styles.suffix_icon}>
            <Icon
              className="cursor-pointer text-grey-200"
              size={18}
              name={showPassword ? "eye" : "eye-slash"}
              onClick={() => setShowPassword(!showPassword)}
            />
          </div>
        )}
        {/* Update lại color sau khi được merge PR */}
        {showCount && (
          <Text
            className={classNames(styles.counter, "ml-2 mr-3")}
            type="body-3"
          >
            {contentLength}
            {rest.maxLength && `/${rest.maxLength}`}
          </Text>
        )}
      </div>

      {hint && <span className={styles.hint}>{hint}</span>}
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default PasswordInput;
